class QuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.body = this.querySelector('[data-quick-view-body]');
    this.isOpen = false;

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-quick-view-close]')) this.close();
    });

    document.addEventListener('keyup', (e) => {
      if (e.code === 'Escape' && this.isOpen) this.close();
    });
  }

  async open(productUrl) {
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('is-visible');

    // Reset to loading state
    this.body.innerHTML = '<div class="quick-view-modal__loading">Loading…</div>';

    try {
      // Append ?view=quick-view to use an alternate template if you have one,
      // otherwise this fetches the regular product page.
      const res = await fetch(productUrl, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('Failed to load product');
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Try a few selectors to find the main product section
      const selectors = [
        '[id*="MainProduct"]',
        '[id^="shopify-section-template--"][id*="product"]',
        '#MainContent main > section:first-of-type',
        '#MainContent main',
        'main'
      ];
      let productSection = null;
      for (const sel of selectors) {
        productSection = doc.querySelector(sel);
        if (productSection) break;
      }

      if (productSection) {
        this.body.innerHTML = productSection.outerHTML;

        // Manually trigger any scripts inside (e.g. variant JSON, custom elements register on connect)
        this.body.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script');
          [...oldScript.attributes].forEach(attr => newScript.setAttribute(attr.name, attr.value));
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      } else {
        this.body.innerHTML = '<p style="padding:40px;text-align:center;">Could not load product details. <a href="' + productUrl + '">View full page →</a></p>';
      }
    } catch (err) {
      console.error('[quick-view]', err);
      this.body.innerHTML = '<p style="padding:40px;text-align:center;">Error loading product.</p>';
    }
  }

  close() {
    this.classList.remove('is-visible');
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.isOpen = false;
    setTimeout(() => {
      if (!this.isOpen) this.body.innerHTML = '';
    }, 300);
  }
}
customElements.define('quick-view-modal', QuickViewModal);

// Trigger handler
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-quick-view-trigger]');
  if (!trigger) return;
  e.preventDefault();
  e.stopPropagation();

  const url = trigger.dataset.productUrl;
  if (!url) return;

  const modal = document.querySelector('quick-view-modal');
  if (modal) modal.open(url);
});